module.exports = __webpack_public_path__ + "bbe756c825a11ea403a5b5ca8f843fd3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/logo-footer.png
 ** module id = 1259
 ** module chunks = 0
 **/